import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";
import { ReactNode } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { sideAnimation } from "../constants";

interface Props {
  multiMixMode: boolean;
}

export default function MobileMixModeButton({ multiMixMode }: Props) {
  return (
    <div className="w-full whitespace-nowrap px-3 py-1 pr-1 focus:outline-none">
      <AnimatePresence mode="popLayout" initial={false}>
        {multiMixMode ? (
          <motion.div key="s" {...sideAnimation}>
            <Template
              title={"Back"}
              icon={(props) => <ChevronLeftIcon {...props} />}
            />
          </motion.div>
        ) : (
          <motion.div key="m" {...sideAnimation}>
            <Template
              title={"Multitrack View"}
              icon={(props) => <ChevronRightIcon {...props} />}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

function Template({
  title,
  icon,
}: {
  title: string;
  icon: (params: { className: string }) => ReactNode;
}) {
  return (
    <div
      key={title}
      className="flex w-full items-center justify-between text-left"
    >
      <div className="font-brik text-base leading-none">{title}</div>

      <div>{icon({ className: "ml-2 h-6" })}</div>
    </div>
  );
}
